import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Header } from './Header.js';
import { Footer } from './Footer.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Home } from './Home.js';
import { Artist } from './Artist.js';
import { Artists } from './Artists.js';
import { Act } from './Act.js';
import { Acts } from './Acts.js';
import { Concerts } from './Concerts.js';
import { Playlist } from './Playlist.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter>
		<Header/>
		<Routes>		
			<Route path="/artist/" element={<Artists/>}/>
			<Route path="/artist/:id" element={<Artist/>}/>
			<Route path="/act/" element={<Acts/>}/>
			<Route path="/act/:id" element={<Act/>}/>
			<Route path="/concert" element={<Concerts/>}/>
			<Route path="/playlist" element={<Playlist/>}/>

			<Route path="*" element={<Home/>} /> 
		</Routes>
		<Footer/>
	</BrowserRouter>
);